module.exports = __webpack_public_path__ + "static/img/1.d06f3e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/pengu/1.png
// module id = lbkK
// module chunks = 35